// Shared modal shell for the three billing dialogs (Manage seats, Cancel
// plan, Turn off auto-pay) — matches design_handoff_account_billing's one
// shared dialog style: blurred backdrop, Esc to close, click-outside to
// close, focus moved into the panel on open.
import React, { useEffect, useRef } from "react";

export default function Dialog({ open, onClose, title, maxWidth = 420, zClass = "z-50", children }) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const previouslyFocused = document.activeElement;
    panelRef.current?.focus();
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      previouslyFocused?.focus?.();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 ${zClass} flex items-center justify-center bg-black/40 p-4`}
      style={{ backdropFilter: "blur(4px)" }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
        className="max-h-[calc(100vh-2rem)] w-full overflow-y-auto rounded-[18px] bg-white p-7 shadow-[0_12px_40px_rgba(26,13,27,0.18)] outline-none"
        style={{ maxWidth }}
      >
        {children}
      </div>
    </div>
  );
}
